/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ProjectTypes, ProjectItemTypes, FloorTypes } from '../../types';
import { PropertiesResponseTypes } from '../../types/response';

export const convertPropertiesResponse = (
  data: PropertiesResponseTypes[]
): {
  projects: ProjectTypes[];
  projectItems: ProjectItemTypes[];
  floors: FloorTypes[];
} => {
  const projects: ProjectTypes[] = [];
  const projectItems: ProjectItemTypes[] = [];
  const floors: FloorTypes[] = [];

  data.forEach((item) => {
    if (!item) return;

    if (item.project && projects.findIndex((i) => i.code === item.project.code)) {
      const { id, ...rest } = item.project;
      projects.push(rest);
    }

    if (item.projectItem && projectItems.findIndex((i) => i.code === item.projectItem.code)) {
      const { id, ...rest } = item.projectItem;
      projectItems.push(rest);
    }

    if (item.floor && floors.findIndex((i) => i.code === item.floor.code)) {
      const { id, ...rest } = item.floor;
      floors.push(rest);
    }
  });

  return { projects, projectItems, floors };
};
